import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    options: {
        customProperties: true
      },
    theme: {
        themes: {
          light: {
            primary: '#2B528C',
            secondary: '#ffffff', //#68AEE0',
            background: '#2B528C', //#343434
            darkgrey: '#1E1E1E',
            greytext: "#424242",
            lightgrey: "#AEAEAE",
            success: '#0A8137',
            warning: '#ffffff',
            bannerColor: "#d00c1f",
            error: '#cc0000',
            errorSnackbar: '#cc0000'
          },
        },
    },
    icons: {
        iconfont: 'mdi' || 'icons8', // default - only for display purposes
    },
});

export default vuetify;
